import type { MessageType } from "@univdiam/ui/type";
import { format } from "date-fns";

type GroupedChat = {
  date: string;
  groups: {
    sender_id: string;
    sender_role: string;
    sender_name: string;
    sender_picture: string | null;
    messages: MessageType[];
  }[];
};

export function groupMessagesByDateAndSender(messages: MessageType[]): GroupedChat[] {
  const grouped: Record<string, GroupedChat> = {};

  let lastSenderId: string | null = null;
  let lastDate: string | null = null;

  messages.forEach((msg) => {
    const date = format(new Date(msg.created_at), "yyyy-MM-dd");

    if (!grouped[date]) {
      grouped[date] = { date, groups: [] };
      lastSenderId = null; // reset when date changes
    }

    const groupList = grouped[date].groups;

    const isSameSender = lastSenderId === msg.sender_id;
    const isSameDate = lastDate === date;

    if (
      isSameSender &&
      isSameDate &&
      groupList.length > 0
    ) {
      groupList[groupList.length - 1]?.messages.push(msg);
    } else {
      groupList.push({
        sender_id: msg.sender_id,
        sender_role: msg.sender_role!,
        sender_name: msg.sender_name!,
        sender_picture: msg.sender_picture!,
        messages: [msg],
      });
    }

    lastSenderId = msg.sender_id;
    lastDate = date;
  });

  return Object.values(grouped);
}
